<template>
  <v-row>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">{{title}}</v-card-title>
        <v-card-text v-html="text"></v-card-text>
        <v-card-actions>
            <v-col cols="12">
              <v-row
                :align="alignment"
                :justify="justify">
                <v-btn  outlined elevation="3" color="success" @click="define">确定</v-btn>
              </v-row>
            </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<style></style>
<script>

  export default {
    name: "alert",
    data() {
      return {
        alignment: 'center',
        justify: 'center',
        title: "提示",
        text: "默认内容",
        dialog: true,
        dark: false
      }
    },
    methods:{
      define(){
        this.dialog = false;
        this.$el.remove() //再点击关闭得时候要将其移出，（仅在第一种方法中使用）
        this.confirmSure()
        this.$destroy()
      }
    }
  }
</script>
